/**
 * Common regex patterns for form validation throughout the application.
 */
export class CommonRegexPatterns {
  /** Phone number format: (###) ###-#### */
  static readonly PHONE = '^([0-9]{3}) [0-9]{3}-[0-9]{4}$';

  /** US ZIP code: 12345 or 12345-1234 */
  static readonly ZIPCODE = '^[0-9]{5}(?:-[0-9]{4})?$';

  /** Social Security Number: ###-##-#### */
  static readonly SSN = '^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$';

  /** Date format: MM/DD/YYYY */
  static readonly DATE = '^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\\d\\d$';

  /** Percentage from 0 to 100 */
  static readonly UP_TO_ONE_HUNDRED_PERCENT = '^(100|[1-9]?[0-9])$';

  /** Numeric value with optional decimal */
  static readonly NUMERIC = '^([0-9]*\\.)?[0-9]+$';

  /** Up to 8 digits with 2 decimal places, allowing zero */
  static readonly EIGHT_DIGIT_WITH_TWO_DECIMAL_ALLOWING_ZERO = '^\\d{1,8}(\\.\\d{1,2})?$';

  /** Up to 8 digits with 2 decimal places, not allowing zero */
  static readonly EIGHT_DIGIT_WITH_TWO_DECIMAL_NOT_ALLOWING_ZERO =
    '(?!^0*$)(?!^0*\\.0*$)^\\d{1,8}(\\.\\d{1,2})?$';

  /** Bank transit number: 9 digits, cannot start with 5 */
  static readonly BANK_TRANSIT_NUMBER = '^(?!5)[0-9]{9}$';

  /**
   * Password with special characters requirement:
   * - At least one lowercase letter
   * - At least one uppercase letter
   * - At least one digit
   * - At least one special character (!@#$%^&*)
   * - Between 6 and 100 characters
   */
  static readonly PASSWORD_SPECIAL_CHARACTERS = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,100})/;

  /**
   * Password without special character requirement:
   * - At least one lowercase letter
   * - At least one uppercase letter
   * - At least one digit
   * - Between 6 and 100 characters
   */
  static readonly PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,100})/;
}
